module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/hospitals/hospital-grid/hospital-grid.component.css
// module id = ./src/app/master/hospitals/hospital-grid/hospital-grid.component.css
// module chunks = main